import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  z-index: 10000;

  left: 0;
  right: 0;
  /* A barra flutua sobre o conteudo em vez de encostar na borda; o safe-area
     evita que ela fique embaixo da barra de gestos do iOS. */
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  position: fixed;

  width: 100%;
  height: auto;
  padding: 0 12px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  /* so a propria barra recebe clique; o resto da faixa deixa passar */
  pointer-events: none;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 350px;
  height: 68px;
  padding: 6px;
  box-sizing: border-box;

  gap: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  pointer-events: auto;

  border-radius: 28px;
  backdrop-filter: blur(24px);
  box-shadow: 0 6px 24px rgba(33, 38, 47, 0.14);

  backdrop-filter: blur(28px) saturate(1.8);

  @media (max-width: 350px) {
   padding: 10px 0;
  }
`;

export const ButtonLink = styled.div`
  width: 100%;
  height: 58px;
  padding: 0 6px;

  gap: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  border-radius: 20rem;
  background-color: ${props => (props.active ? '#21262f14' : 'transparent' )};

  /* O item de Receita era um circulo verde destacado; na barra flutuante os
     cinco itens seguem o mesmo tratamento. O icone continua o mesmo. */
  &:nth-of-type(3){
    gap: 0rem;

    svg{
      width: 24px;
      height: auto;
    }

    svg > g > g > path {
      fill: ${props => props.active === true ? theme.colors.gray.Cinza_2 : theme.colors.gray.Cinza_2} !important;
    }
  }
`;

export const Link = styled.a`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  /* border-radius: 16px;
  --link-bg: ${props => (props.active ? theme.colors.green.Verde_AgroReceita : theme.colors.white.Branco )};
  background-color: var(--link-bg); */

  >img{
    width: 24px;
    height: auto;
  }

  >svg > g > path {
    fill: ${props => props.active === true ? theme.colors.gray.Cinza_2 : theme.colors.gray.Cinza_2} !important;
  }

  svg > g > g > path {
    fill: ${props => props.active === true ? theme.colors.gray.Cinza_2 : theme.colors.gray.Cinza_2} !important;
  }
`;
